import { ReactChild, ReactNode } from 'react';
import { useToggle } from '@mews/framework';
import { Accordion } from '@optimus-web/core';

interface Props {
    primaryText: ReactNode;
    body: ReactChild;
}

export const PaymentMethodDetailStatusHistoryAccordion = ({ primaryText, body }: Props) => {
    const [expanded, toggleExpanded] = useToggle();

    return (
        <Accordion
            expanded={expanded}
            onClick={toggleExpanded}
            headerPadding={{ top: '0', bottom: '0', left: '0', right: '0' }}
            title={primaryText}
            body={body}
            bodyPadding="0"
            withHeaderBorder={!expanded}
        />
    );
};
